export default __webpack_public_path__ + "img/dcZjeFMx.d060536e.svg";